import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: `${environment.keycloak.url}/realms/${environment.keycloak.realm}`,
  redirectUri: window.location.origin,
  clientId: environment.keycloak.clientId,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: true,
  requireHttps: false, // dev only
  postLogoutRedirectUri: window.location.origin,
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
  timeoutFactor: 0.75,
  sessionChecksEnabled: true,
  clearHashAfterLogin: true,
  strictDiscoveryDocumentValidation: false, // ✅ Dodaj ovo
  skipIssuerCheck: false, // ✅ Ne pres
};
